import Home from "./pages/Home";

function App() {
  return (
    <div className="w-full h-full">
      <Home />
    </div>
  );
}

export default App;
